import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import 'react-tabs/style/react-tabs.css';


import * as PD from '../classes/pdStyle';

import {cloneObject, getParam} from '../utils/utils';
import {formatDate, formatText, truncate} from '../utils/utils';


import dsd from "../classes/clsDSD";

import D3Graphviz from "../components/D3Graphviz";

import ViewLogicalModel from "../components/ViewLogicalModel";
import ViewMetadata from "../components/ViewMetadata";
import ListEntities from "../components/ListEntities";
import ListRelationships from "../components/ListRelationships";

import Version from "../components/Version";
import ListVersions from "../components/ListVersions";
import ViewLogicalModelVersion from "../components/ViewLogicalModelVersion";

import Rendition from '../components/Rendition';

import ViewVersion from "../components/ViewVersion";
import {zipLogicalModel} from "../utils/utilsLogicalModel";
import { assetsLogicalModelVersion } from "../utils/utilsLogicalModel";
import { Reply } from "react-bootstrap-icons";


import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

import Buffering from "../components/Buffering";

import {getLogicalModel, addLogicalModel, editLogicalModel } from '../utils/utilsLogicalModel';

import JSZip from "jszip";


class LogicalModel extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            isLoaded: false,
            loadData:false
        };


        this.data = {};
        this.viz = null;
        this.vizEngine = "dot";

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);

        this.handleEntityFilters = this.handleEntityFilters.bind(this);
        this.handleRelationshipFilters = this.handleRelationshipFilters.bind(this);

        this.handleExport = this.handleExport.bind(this);

        this.handleAddVersion = this.handleAddVersion.bind(this);
        this.VersionOnActioned = this.VersionOnActioned.bind(this);
        this.loadedVersions = this.loadedVersions.bind(this);
        this.loadedEntities = this.loadedEntities.bind(this);
        this.loadedRelationships = this.loadedRelationships.bind(this);





        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/logicalmodels`;


    }

    componentDidMount(){

       this.setup();

    }


    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadLogicalModel(id){

        let StateChange = {};
        StateChange.LogicalModel = null;

        const onLoad = function(data){
            let StateChange = {};
            StateChange.LogicalModel = data;

            StateChange.FormData = data;

            StateChange.renderState = "loaded";
            StateChange.isLoaded = true;

            StateChange.OfferEdit = false;
            try{
                if (this.dsd.loggedon){
                    if (StateChange.LogicalModel.idUser == this.dsd.user.id){
                        StateChange.OfferEdit = true;
                    }
                }
            }
            catch{

            }   

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "edit":
                    case "remove":
                        StateChange.renderState = "denied"
                        StateChange.errorMessage = "You cannot edit this Logical Model"
                    break;
                }
            }

            if (this.context.hasLayout){
                this.context.Layout.setLeftAsLogicalModel(data._id);
            }

            // Update breadcrumb
            if (id){
                for (var i in window.Breadcrumb){
                    if (window.Breadcrumb[i][0] === 'logicalmodel'){
                        window.Breadcrumb = window.Breadcrumb.slice(0,i);
                        break;
                    }
                }
                this.Breadcrumb = JSON.parse(JSON.stringify(window.Breadcrumb));
    
                window.Breadcrumb.push(['logical model',`/logicalmodel/${id}`]);

                this.FallBackNavigation = `../logicalmodels`;
                this.onUpdateNavigation = this.FallBackNavigation;
            }

            // Fetch DOT from server
            this.fetchViz(id);

            this.setState(StateChange);
            return;
        }.bind(this);

        const onFail = function(e){
            let StateChange = {};
            StateChange.LogicalModel = null;
            StateChange.renderState = "failed";

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);

        if (id){
            StateChange.renderState = "loading";
            getLogicalModel(this.dsd, id, onLoad, onFail);
        }

        this.setState(StateChange);

        return;
        
    };

    fetchViz(id) {

        const onDoneDot = function(dot) {
            this.setState({ dot: dot });
        }.bind(this);

        const onFailDot = function(error) {
            console.error('Failed to fetch DOT:', error);
        }.bind(this);

        getLogicalModel(this.dsd, id, onDoneDot, onFailDot, 'dot', null, this.state.Controls);

    };

    async loadVersionAssets(id, idVersion){

        if (!id || idVersion == null){
            return;
        }

        this.setState({ renderState: 'loading' });

        const assets = await assetsLogicalModelVersion(this.dsd, id, idVersion);

        this.setState({
            mdVersionPage: assets["page.md"],
            VersionAssets: assets,
            isLoaded: true,
            renderState: 'loaded'
        });

        return;
        
    };

    setup(){


        let StateChange = {
            id: null,
            isLoaded: false,
            isUpdated: false,
            isFailed: false,
            errorMessage: null,
            renderState: null,

            OfferEdit: false,

            FormData: {},
            Controls: {
                vizStructures: false
            },

            EntityFilters: {
                status:'in use'
            },
            RelationshipFilters: {
                status:'in use'
            },


            LogicalModel: null,
            Entities: null,
            Relationships: null,

            idVersion: null,

            action: null,

            updateToggle: 0,

            countVersions: null,
            countEntities : null,
            countRelationships : null,

            dot: null,

        }

        StateChange.mode = getParam('mode', this.props);
        StateChange.idLogicalModel = getParam('id', this.props);

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        StateChange.idVersion = getParam('idVersion', this.props);


        this.setState(StateChange, async () => {

           if (this.state.idVersion){
               await this.loadVersionAssets(this.state.idLogicalModel, this.state.idVersion);
               if (this.context.hasLayout){
                   this.context.Layout.setLeftAsLogicalModelVersions(this.state.idLogicalModel);
               }
               return;
           }

            if (this.state.idLogicalModel){
                this.loadLogicalModel(this.state.idLogicalModel);
            }

       });
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let FormData = this.state.FormData;
        FormData[FormFieldName] = FormFieldValue;        
        this.setState({"FormData": FormData});

        return;

    };
    
    handleEntityFilters(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let EntityFilters = this.state.EntityFilters;
        EntityFilters[FormFieldName] = FormFieldValue;
        this.setState({"EntityFilters": EntityFilters});

        return;

    };


    handleRelationshipFilters(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let RelationshipFilters = this.state.RelationshipFilters;
        RelationshipFilters[FormFieldName] = FormFieldValue;
        this.setState({"RelationshipFilters": RelationshipFilters});

        return;

    };


    handleSubmit(event) {

        const onError = function(e){
            let StateChange = {};
            StateChange.isFailed = true;
            StateChange.errorMessage = e.message;

            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                    if (e.response.data.fields){
                        StateChange.invalidFields = e.response.data.fields
                    }

                }
            }

            this.setState(StateChange);
            return;
        }.bind(this);

        window.scrollTo(0, 0);

        switch (event.target.name){
            case 'btnCancel':

                switch (this.state.mode){
                    case 'new':
                        this.props.navigation(this.FallBackNavigation);
                        break;
                    case 'edit':
                        this.props.navigation(`/logicalmodel/${this.state.idLogicalModel}`);
                        break;
        //            case 'remove':
        //                this.savviconfig.removeFactor(this.data.idProject,this.type,this.data.idFactor);
        //                break;  
                    default:
                        break; 
                };

                break;
            case 'btnSave':
            default:

                this.setState({
                    isUpdated: false,
                    isFailed: false,
                    invalidFields: false
                })
        
                switch (this.state.mode){
                    case 'new':
                        const onAdd = function(idLogicalModel){
                            this.props.navigation(`/logicalmodel/${idLogicalModel}`);
                        }.bind(this);

                        addLogicalModel(this.dsd, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        const onUpdate = function(){
                            this.props.navigation(`/logicalmodel/${this.state.idLogicalModel}`);
                           return;
                        }.bind(this);

                        editLogicalModel(this.dsd, this.state.idLogicalModel, this.state.FormData, onUpdate, onError);

                        break;
        //            case 'remove':
        //                this.savviconfig.removeFactor(this.data.idProject,this.type,this.data.idFactor);
        //                break;  
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
            case 'btnAddEntity':
                this.props.navigation(`/logicalmodel/${this.state.idLogicalModel}/entity?mode=new`);
                break;
            case 'btnAddRelationship':
                this.props.navigation(`/logicalmodel/${this.state.idLogicalModel}/relationship?mode=new`);
                break;
        }

        this.setState(StateChange);

        event.preventDefault();
    };

    handleAddVersion(event) {

        this.setState({newVersion:true});

    }


    handleVizClick(event) {

        let idNode = null;
        if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }
        
        if (idNode){
            let partsVizNodeId = idNode.split('_');
            switch(partsVizNodeId[0]){
                case 'concept':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/concept/${partsVizNodeId[1]}`);
                    }
                    break;
                case 'entity':
                    if (partsVizNodeId.length > 3){
                        switch(partsVizNodeId[2]){
                            case 'structure':
                                this.props.navigation(`/structure/${partsVizNodeId[3]}`);
                                break;
                            case 'enumeration':
                                this.props.navigation(`/enumeration/${partsVizNodeId[3]}`);
                                break;
                        }
                    }else{
                        if (partsVizNodeId.length > 1){
                            this.props.navigation(`/entity/${partsVizNodeId[1]}`);
                        }
                    }
                    break;
                case 'structure':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/structure/${partsVizNodeId[1]}`);
                    }
                    break;
                case 'enumeration':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/enumeration/${partsVizNodeId[1]}`);
                    }   
                    break;
            }
        }

        event.preventDefault();

    };

    log(){

        if (!this.state.isLoaded){
            return null;
        }

        if (!this.state.LogicalModel){
            return null;
        }

        let arrLog = [];
        for (let pos=0;pos<this.state.LogicalModel.Entities.length;pos++){
            let Entity = this.state.LogicalModel.Entities[pos];
            if (Entity.createdAt){
                let LogEntry = {};
                LogEntry.date = Entity.createdAt;
                LogEntry.action = 'created';
                LogEntry.subjectType = 'Entity';
                LogEntry.Subject = Entity;
                LogEntry.name = Entity.name;
                LogEntry.link = `/entity/${Entity._id}`;
                arrLog = this.insertLog(arrLog, LogEntry);
            }
            if (Entity.Revisions){
                for (let posR=0; posR<Entity.Revisions.length;posR++){
                    let Revision = Entity.Revisions[posR];
                    if (Revision.report){
                        let LogEntry = {};
                        LogEntry.date = Revision.createdAt;
                        LogEntry.action = 'revised';
                        LogEntry.subjectType = 'Entity';
                        LogEntry.Subject = Entity;
                        LogEntry.name = Entity.name;
                        LogEntry.link = `/entity/${Entity._id}`;
                        LogEntry.Revision = Revision
                        LogEntry.description = Revision.description;
                        arrLog = this.insertLog(arrLog, LogEntry);
                    }
                }
            }
        }

        for (let pos=0;pos<this.state.LogicalModel.Relationships.length;pos++){
            let Relationship = this.state.LogicalModel.Relationships[pos];


            let label = "-";
            try {
              if (Relationship.Link){
                label = `${Relationship.Link.ConceptFrom.name} ${Relationship.Link.label} ${Relationship.Link.ConceptTo.name}`;
                if (Relationship.inverse){
                    label = `${Relationship.Link.ConceptTo.name} ${Relationship.Link.inverseLabel} ${Relationship.Link.ConceptFrom.name}`;
                }
              }
            } catch { };
          

            if (Relationship.createdAt){
                let LogEntry = {};
                LogEntry.date = Relationship.createdAt;
                LogEntry.action = 'created';
                LogEntry.subjectType = 'Relationship';
                LogEntry.Subject = Relationship;
                LogEntry.name = label;
                LogEntry.link = `/relationship/${Relationship._id}`;
                arrLog = this.insertLog(arrLog, LogEntry);
            }
            if (Relationship.Revisions){
                for (let posR=0; posR<Relationship.Revisions.length;posR++){
                    let Revision = Relationship.Revisions[posR];
                    if (Revision.report){
                        let LogEntry = {};
                        LogEntry.date = Revision.createdAt;
                        LogEntry.action = 'revised';
                        LogEntry.subjectType = 'Relationship';
                        LogEntry.Subject = Relationship;
                        LogEntry.name = label;
                        LogEntry.link = `/relationship/${Relationship._id}`;
                        LogEntry.Revision = Revision
                        LogEntry.description = Revision.description;
                        arrLog = this.insertLog(arrLog, LogEntry);                       
                    }
                }
            }
        }

        if (!arrLog.length){
            return null;
        }

        return (
            <PD.Table>
                <PD.Thead>
                    <PD.Tr>
                        <PD.Th>on</PD.Th>
                        <PD.Th>what</PD.Th>
                        <PD.Th>name</PD.Th>
                        <PD.Th>change</PD.Th>
                        <PD.Th>description</PD.Th>
                    </PD.Tr>
                </PD.Thead>

                <PD.Tbody>
                    {
                        arrLog.map(
                        (entry, pos) => 
                            {
                                return (
                                    <PD.Tr key={pos}>
                                        <PD.Td>{formatDate(entry.date,'dmy')}</PD.Td>
                                        <PD.Td>{entry.subjectType}</PD.Td>
                                        <PD.Td>
                                            <PD.PdNavLink to={entry.link} >{entry.name}</PD.PdNavLink>
                                        </PD.Td>
                                        <PD.Td>{entry.action}</PD.Td>
                                        <PD.Td>{formatText(truncate(entry.description, 400))}</PD.Td>
                                    </PD.Tr>
                                )
                            }
                        )
                    }
                </PD.Tbody>
            </PD.Table>

        )


    }

    insertLog(array, entry){

        let boolInserted = false;

        let newArray = [];

        for (let pos=0; pos<array.length;pos++){
            if (!boolInserted){
                if (entry.date < array[pos].date){
                    newArray.push(entry);
                    boolInserted = true;
                }
            }
            newArray.push(array[pos]);
        }

        if (!boolInserted){
            newArray.push(entry);
        }

        return newArray;

    }


    versions(){

        if (!this.state.isLoaded){
            return null;
        }

        if (!this.state.LogicalModel){
            return null;
        }

        let newVersion = false;
        let showAdd = false;

        if (this.state.OfferEdit){
            showAdd = true;
        }
        if (this.state.newVersion){
            showAdd = false;
            newVersion = true;
        }

        return (
            <div>
                {showAdd &&
                    <div style={{display:"flex"}}>
                        <PD.Button name='btnAdd' value='add a Named Version' onClick={this.handleAddVersion}/>
                    </div>
                }
                
                {newVersion &&
                    <Version mode='new' idAbout={this.state.idLogicalModel} type='logicalmodel' onActioned={this.VersionOnActioned}/>
                }
                <ListVersions key={this.state.updateToggle} OfferEdit={this.state.OfferEdit} filters={{idAbout:this.state.idLogicalModel}} onLoad={this.loadedVersions}/>

            </div>
        )
    }

    VersionOnActioned(){
       this.setState(
        {
            newVersion:false,
            updateToggle: Number(!this.state.updateToggle)
        })
    }

    loadedVersions(count){

        let StateChange = {};

        StateChange.countVersions = 0;
        if (count){
            StateChange.countVersions = count;
        }

        this.setState(StateChange);

    }

    loadedEntities(count){

        let StateChange = {};

        StateChange.countEntities = 0;
        if (count){
            StateChange.countEntities = count;
        }

        this.setState(StateChange);

    }

    loadedRelationships(count){

        let StateChange = {};

        StateChange.countRelationships = 0;
        if (count){
            StateChange.countRelationships = count;
        }

        this.setState(StateChange);

    }

    async handleExport(event){

        this.setState({isExporting: true});
        try {
            let idLogicalModel = this.state.idLogicalModel;
            let idVersion = this.state.idVersion;
            let zipData = null;
            let link = null;

            zipData = await zipLogicalModel(this.dsd, idLogicalModel, idVersion);

            link = document.createElement("a");
            link.href = window.URL.createObjectURL(zipData);
            link.download = `logicalmodel_${idLogicalModel}_version_${idVersion}.zip`;
            link.click();
        } finally {
            this.setState({isExporting: false});
        }
    }


    visualise(){
    
        if (!this.state.LogicalModel){
            return <Buffering/>;
        }

        const onChangeVizControl = function(event){

            const FormFieldName = event.target.name;
            let FormFieldValue = event.target.value;

            if (event.target.type == "checkbox"){
                FormFieldValue = event.target.checked;
            }

            let Controls = this.state.Controls;
            Controls[FormFieldName] = FormFieldValue;
            this.setState({Controls:Controls}, () => {
                this.fetchViz(this.state.idLogicalModel);
            });
        }.bind(this);


        try {

            return(
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    Structures <input type="checkbox" name="vizStructures" onChange={onChangeVizControl} checked={this.state.Controls.vizStructures}/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div name="divViz" onClick={this.handleVizClick}>
                        {this.state.dot
                            ? <D3Graphviz dot={this.state.dot}/>
                            : <Buffering/>
                        }
                    </div>

                </div>
            );
          } catch (error) {
            return <div/>
          }
    };


    showError(){


        if (this.state.invalidFields){
            return(
                <>
                    {
                        Object.keys(this.state.invalidFields).map(
                        (field, pos) => 
                            {
                                let error = this.state.invalidFields[field].error;
                                return <p key={pos}>{field}:{error}</p>
                            }
                        )
                    }
                </>
            )
        }

        return "ERROR - Failed to Update";

    }


    render() {

        // Handle render states for loading, errors, etc.
        switch (this.state.renderState){
            case "loading":
                return <Buffering/>
            case "failed":
            case "denied":
                let Message = "An error has occurred";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
        }

        if (this.state.isUpdated){
            switch (this.state.mode){
                case 'remove':
                    this.props.navigation(this.FallBackNavigation);
                    return null;
                default:
                    break;
            };
        };

 /*       
        // Handle viewing a specific version
        if (this.state.idVersion){
            return(
                <ViewLogicalModelVersion idLogicalModel={this.state.idLogicalModel} idVersion={this.state.idVersion}/>
            )
        }
*/
        if (this.state.idVersion){
            return(
                <div>
                    <PD.Button onClick={ () => this.props.navigation(`/logicalmodel/${this.state.idLogicalModel}`) } value="back"><Reply/></PD.Button>
                    <PD.Button onClick={this.handleExport} name="btnExport" value={this.state.isExporting ? "" : "export"}>
                        {this.state.isExporting && <Buffering/>}
                    </PD.Button>
                    <ViewVersion mdPage={this.state.mdVersionPage} assets={this.state.VersionAssets} idVersion={this.state.idVersion}/>
                </div>
            )
        }


        // Handle new mode without data
        if (this.state.mode === 'new'){
            return (
                <div>

                    <PD.Heading>{this.state.mode} Logical Model</PD.Heading>

                    {this.state.isFailed &&
                        <PD.ErrorBox>{this.showError()}</PD.ErrorBox>
                    }

                    <form> 
                        <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                        <PD.Editor name="description" label='Description' value={this.state.FormData.description} onChange={this.handleChange}/>

                        <PD.Input label="Namespace" width="30" name="namespace" value={this.state.FormData.namespace} onChange={this.handleChange}/>
                        <PD.Input label="Default Prefix" width="10" name="prefix" value={this.state.FormData.prefix} onChange={this.handleChange}/>

                        <PD.Editor name="proposals" label='Proposals' value={this.state.FormData.proposals} onChange={this.handleChange}/>

                        <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                            {
                                this.dsd.config.ComponentStatuses.map(
                                    (status, posStatus) => 
                                        {
                                            return(
                                                <option key={posStatus} value={status}>{status}</option>
                                            )
                                        }
                                )
                            }
                        </PD.Select>

                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave"value="Save" />    
                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" />    
                    </form>

                </div>    
            );
        }

        // For view and edit modes, we need the LogicalModel loaded
        if (this.state.renderState === 'loaded' && this.state.LogicalModel) {

            switch (this.state.mode){
                case 'edit':

                    return (
                    <div>

                        <PD.Heading>{this.state.mode} Logical Model</PD.Heading>
    
                        {this.state.isFailed &&
                            <PD.ErrorBox>{this.showError()}</PD.ErrorBox>
                        }
    
                        <form> 
                            <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                            <PD.Editor name="description" label='Description' value={this.state.FormData.description} onChange={this.handleChange}/>

                            <PD.Input label="Namespace" width="30" name="namespace" value={this.state.FormData.namespace} onChange={this.handleChange}/>
                            <PD.Input label="Default Prefix" width="10" name="prefix" value={this.state.FormData.prefix} onChange={this.handleChange}/>

                            <PD.Editor name="proposals" label='Proposals' value={this.state.FormData.proposals} onChange={this.handleChange}/>

                            <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                                {
                                    this.dsd.config.ComponentStatuses.map(
                                        (status, posStatus) => 
                                            {
                                                return(
                                                    <option key={posStatus} value={status}>{status}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>

                            <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave"value="Save" />    
                            <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" />    
                        </form>
    
                    </div>    
                    );
                case 'remove':
                    return (
                        <div>
                            <PD.Heading>{this.state.mode} Logical Model</PD.Heading>

                            {this.state.isFailed &&
                                <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                            }

                            <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                            <ViewLogicalModel json={this.state.LogicalModel}/>
                        </div>
                    )
                case 'view':
                default:

                    return (
                        <div>
                            <div>
                                <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                <PD.Heading>Logical Model:{this.state.LogicalModel.name}</PD.Heading>
                            </div>

                            {this.state.OfferEdit &&
                                <span style={{paddingRight:10}}>
                                        <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                </span>
                            }

                            <ViewLogicalModel LogicalModel={this.state.LogicalModel}/>

                            <br/>

                            <PD.Tabs>

                                <div label='Visualise'>
                                    {this.visualise()}
                                </div>


                                <div label={<span>Entities({this.state.countEntities === null ? <Buffering/> : this.state.countEntities})</span>}  data-forcerender="true">
                                    <div style={{display:"flex"}}>
                                        {this.state.OfferEdit && 
                                            <PD.Button name='btnAddEntity' value='add a new Entity' onClick={this.handleButton}/>
                                        }
                                        <fieldset style={{display:"flex"}}>
                                            <legend>filters</legend>
                                            <PD.Select label='status' name='status'  onChange={this.handleEntityFilters} value={this.state.EntityFilters.status}>
                                                {
                                                    this.dsd.config.EntityStatuses.map(
                                                        (status, posStatus) => 
                                                            {
                                                                return(
                                                                    <option key={posStatus} value={status}>{status}</option>
                                                                )
                                                            }
                                                    )
                                                }
                                            </PD.Select>
    
                                        </fieldset>
                                    </div>

                                    <ListEntities filters={{idLogicalModel:this.state.idLogicalModel, ...this.state.EntityFilters}} onLoad={this.loadedEntities} />
                                </div>

                                <div label={<span>Relationships({this.state.countRelationships === null ? <Buffering/> : this.state.countRelationships})</span>}  data-forcerender="true">
                                    <div style={{display:"flex"}}>
                                        {this.state.OfferEdit && 
                                            <PD.Button name='btnAddRelationship' value='add a new Relationship' onClick={this.handleButton}/>
                                        }
                                        <fieldset style={{display:"flex"}}>
                                            <legend>filters</legend>
                                            <PD.Select label='status' name='status'  onChange={this.handleRelationshipFilters} value={this.state.RelationshipFilters.status}>
                                                {
                                                    this.dsd.config.RelationshipStatuses.map(
                                                        (status, posStatus) => 
                                                            {
                                                                return(
                                                                    <option key={posStatus} value={status}>{status}</option>
                                                                )
                                                            }
                                                    )
                                                }
                                            </PD.Select>
    
                                        </fieldset>
                                    </div>

                                    <ListRelationships filters={{idLogicalModel:this.state.idLogicalModel, ...this.state.RelationshipFilters}} onLoad={this.loadedRelationships}  />
                                </div>

                                <div label='Log'>
                                    {this.log()}
                                </div>

                                <div label={<span>Versions({this.state.countVersions === null ? <Buffering/> : this.state.countVersions})</span>}  data-forcerender="true">
                                    {this.versions()}
                                </div>


                                <div label='Developer'>
                                    <Rendition
                                        endpoint="/logicalmodels"
                                        id={this.state.idLogicalModel}
                                    />
                                </div>


                                <div label='Metadata'>
                                    <ViewMetadata Data={this.state.LogicalModel} />
                                </div>


                            </PD.Tabs>


                        </div>
                    )
            }
        }

        return <div />;
    };
};

// Wrap and export
export default function LogicalModel_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <LogicalModel {...props} navigation={navigation} location={location} params={params} />;
  }
